import React from 'react';
import './error404.css';
import Btn from '../components/common/button';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import Preloader from '../components/layout/preloader';

const Error404 = () => {
        const [loading, setLoading] = useState(true)
    
        useEffect(() => {
          const timer = setTimeout(() => {
            setLoading(false)
          }, 2000)
      
          return () => clearTimeout(timer)
        }, [])
      
        if (loading) {
          return <Preloader />
        }

    return ( 
        <>
        <div className="bg"></div>
        <section className='error'>
            <h4>ERROR 404</h4>
            <p>The page you seek has <br /> vanished into the shadows…</p>
            <Link to="/">
                <Btn btnText="Back to Home" />
            </Link>
        </section>
        </>
     );
}
 
export default Error404;